import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import IronPayment from 'images/IronPaymentsIcon.svg';
import IronWallet from 'images/IronWalletIcon.svg';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import React from 'react';
import SkyPayment from 'images/SkyPaymentsIcon.svg';
import SkyWallet from 'images/SkyWalletIcon.svg';

const additionalButtonStyle = {
  height: '10rem'
};

const buttonHeaderStyle = {
  fontSize: '16px'
};

const buttonSubtextStyle = {
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '16px'
};

const page9 = {
  defaultNextPage: window.AppConfig.hide_bank_info_section
    ? 'page-13'
    : 'page-10',
  content: [
    configureProgressBar(59),
    configureTitle('How are you paid?'),
    {
      component: ButtonGroup,
      name: 'paymentType',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'paymentType',
        direction: 'column',
        additionalButtonStyle,
        options: [
          {
            displayValue: 'Direct Deposit',
            id: 'paymentTypeDirectDeposit',
            value: 'direct_deposit',
            unselectedChildren: (
              <div>
                <IronWallet />
                <p css={buttonHeaderStyle}>Direct Deposit</p>
                <p css={buttonSubtextStyle}>
                  My income is automatically deposited into my bank account.
                </p>
              </div>
            ),
            selectedChildren: (
              <div>
                <SkyWallet />
                <p css={[buttonHeaderStyle, { fontWeight: 700 }]}>
                  Direct Deposit
                </p>
                <p css={buttonSubtextStyle}>
                  My income is automatically deposited into my bank account.
                </p>
              </div>
            )
          },
          {
            displayValue: 'Cash or Check',
            id: 'paymentTypeOther',
            value: 'other',
            unselectedChildren: (
              <div>
                <IronPayment />
                <p css={buttonHeaderStyle}>Cash or Check</p>
                <p css={buttonSubtextStyle}>
                  I receive cash, checks or other forms of payment that I
                  deposit into my bank account.
                </p>
              </div>
            ),
            selectedChildren: (
              <div>
                <SkyPayment />
                <p css={[buttonHeaderStyle, { fontWeight: 700 }]}>
                  Cash or Check
                </p>
                <p css={buttonSubtextStyle}>
                  I receive cash, checks or other forms of payment that I
                  deposit into my bank account.
                </p>
              </div>
            )
          }
        ]
      }
    },
    nextButtonConfig('page-9')
  ]
};
export default page9;
